import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import ReactTable, { ReactTableDefaults } from 'react-table';

import {
  AdminLicenseInTableMenu,
  ReactTableFilterAzSearch,
  ReactTableFilterDatePicker,
  ReactTableFilterDropdown,
  ReactTableSearch,
  ReactTablePagination,
  ReactTableHeaderText,
  Loading
} from 'components';
import * as commonVar from 'libs/commonVar';

import { Icon, Image } from 'semantic-ui-react';

import moment from 'moment';
import 'moment/locale/ko';
import 'moment/locale/ja';

import classNames from 'classnames/bind';
import styles from './AdminLicenseList.css';
const cx = classNames.bind(styles);

moment.locale(localStorage.getItem('language'));

const fromNowClass = [];
class AdminLicenseList extends PureComponent {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    // 검색 (상단)
    const { data, searchObj, fromNowView, isAuth, handleChangeDateFilter, ...rest } = this.props;
    // 필터
    const { statusFilter, licenseTypeFilter, cancleCheck, filterClose, executeFilter, onFilterCancel } = this.props;
    // 현재 페이지 이동 (하단)
    const { handlePagination } = this.props;
    const columns = [
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminLicenseList_1', defaultMessage: '서비스No' }))}
          />
        ),
        accessor: 'serviceNo',
        resizable: false,
        sortable: true,
        minWidth: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center number-text'),
        Cell: props => {
          return props.value ? props.value : '-';
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminLicenseList_2', defaultMessage: '서비스명' }))}
          />
        ),
        accessor: 'serviceName',
        sortable: true,
        minWidth: 143,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center sub-text'),
        Cell: props => {
          return props.value ? props.value : '-';
        }
      },
      {
        Header: <ReactTableHeaderText title={'No'} />,
        accessor: 'licenseNo',
        sortable: true,
        resizable: false,
        width: 72,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center number-text'),
        Cell: props => {
          return props.value ? props.value : '-';
        }
      },
      // {
      //   Header: (
      //     <ReactTableHeaderText
      //       title={defineMessages(formatMessage({ id: 'AdminLicenseList_3', defaultMessage: '도메인' }))}
      //     />
      //   ),
      //   accessor: 'serviceDomain',
      //   sortable: true,
      //   minWidth: 137,
      //   headerClassName: cx('react-table-th'),
      //   className: cx('react-table-td'),
      //   Cell: props => {
      //     return props.value ? props.value : '-';
      //   }
      // },
      {
        Header: ({ ...rest }) => {
          const listItem = [
            {
              key: '1',
              text: defineMessages(formatMessage({ id: 'LicenseEdit_27', defaultMessage: '영구' })),
              value: 1
            },
            {
              key: '2',
              text: defineMessages(formatMessage({ id: 'LicenseEdit_28', defaultMessage: '기간' })),
              value: 2
            },
            {
              key: '4',
              text: defineMessages(formatMessage({ id: 'LicenseEdit_29', defaultMessage: '횟수' })),
              value: 4
            }
          ];

          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'LicenseEdit_23', defaultMessage: '라이센스 타입' }))}
              // filter={
              //   <ReactTableFilterDropdown
              //     isMulti
              //     listItem={listItem}
              //     filter={searchObj.filterData}
              //     handleChangeFilter={handleChangeFilter}
              //     column={rest.column.id}
              //   />
              // }
            />
          );
        },
        accessor: 'licenseType',
        sortable: true,
        resizable: false,
        minWidth: 143,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ value }) => {
          let printValue = '-';
          if (value === 1) {
            printValue = defineMessages(formatMessage({ id: 'LicenseEdit_24', defaultMessage: '영구 라이센스' }));
          } else if (value === 2) {
            printValue = defineMessages(formatMessage({ id: 'LicenseEdit_25', defaultMessage: '기간 라이센스' }));
          } else if (value === 4) {
            printValue = defineMessages(formatMessage({ id: 'LicenseEdit_26', defaultMessage: '횟수 라이센스' }));
          } else {
            //
          }
          return printValue;
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'LicenseEdit_30', defaultMessage: '훈련 횟수' }))}
          />
        ),
        sortable: false,
        resizable: false,
        accessor: 'examLimitCount',
        minWidth: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: props => {
          if (props.original.licenseType === 4) {
            return (
              props.original.examUsedCount +
              ' / ' +
              props.original.examLimitCount +
              ' ' +
              defineMessages(formatMessage({ id: 'LicenseEdit_31', defaultMessage: '회' }))
            );
          } else {
            return '-';
          }
        }
      },
      {
        Header: ({ ...rest }) => {
          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'AdminLicenseList_5', defaultMessage: '시작일자' }))}
              filter={
                <ReactTableFilterDatePicker
                  {...rest}
                  filter={searchObj.filterData}
                  onChange={data => {
                    handleChangeDateFilter('StartEpoch', data);
                  }}
                />
              }
            />
          );
        },
        accessor: 'startEpoch',
        minWidth: 110,
        sortable: true,
        resizable: false,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ value }) => {
          const dateFormat = localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD';
          return value ? (
            <div>
              <span className={cx('start-date-normal')}>{moment.unix(value).format(dateFormat)}</span>
              <span className={cx('start-date-fromnow')}>{moment.unix(value).fromNow()}</span>
            </div>
          ) : (
            '-'
          );
        }
      },
      {
        Header: ({ ...rest }) => {
          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'AdminLicenseList_6', defaultMessage: '종료일자' }))}
              filter={
                <ReactTableFilterDatePicker
                  {...rest}
                  filter={searchObj.filterData}
                  onChange={data => {
                    handleChangeDateFilter('EndEpoch', data);
                  }}
                />
              }
            />
          );
        },
        accessor: 'endEpoch',
        minWidth: 110,
        sortable: true,
        resizable: false,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ value }) => {
          const dateFormat = localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD';
          return value ? (
            <div>
              <span className={cx('end-date-normal')}>{moment.unix(value).format(dateFormat)}</span>
              <span className={cx('end-date-fromnow')}>{moment.unix(value).fromNow()}</span>
            </div>
          ) : (
            '-'
          );
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminLicenseList_4', defaultMessage: '훈련 대상' }))}
          />
        ),
        accessor: 'targetCount',
        sortable: true,
        resizable: false,
        minWidth: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: props => {
          return props.value
            ? props.value + defineMessages(formatMessage({ id: 'LicenseList_6', defaultMessage: '명' }))
            : '-';
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'LicenseListRow_4', defaultMessage: '수량' }))}
          />
        ),
        accessor: 'targetUsedCount',
        sortable: true,
        resizable: false,
        minWidth: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: props => {
          return props.value
            ? props.value + defineMessages(formatMessage({ id: 'LicenseList_6', defaultMessage: '명' }))
            : '-';
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminLicenseList_7', defaultMessage: '구매 수량' }))}
          />
        ),
        accessor: 'licenseCount',
        sortable: true,
        resizable: false,
        minWidth: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: props => {
          return props.value
            ? props.value + defineMessages(formatMessage({ id: 'LicenseList_6', defaultMessage: '명' }))
            : '-';
        }
      },
      {
        Header: ({ ...rest }) => {
          const listItem = [
            {
              key: '-1',
              text: defineMessages(formatMessage({ id: 'AdminLicenseList_9', defaultMessage: '미존재' })),
              value: '-1'
            },
            {
              key: '0',
              text: defineMessages(formatMessage({ id: 'AdminLicenseList_10', defaultMessage: '신청' })),
              value: '0'
            },
            {
              key: '1',
              text: defineMessages(formatMessage({ id: 'AdminLicenseList_11', defaultMessage: '사용중' })),
              value: '1'
            },
            {
              key: '2',
              text: defineMessages(formatMessage({ id: 'AdminLicenseList_12', defaultMessage: '사용대기' })),
              value: '2'
            },
            {
              key: '3',
              text: defineMessages(formatMessage({ id: 'AdminLicenseList_13', defaultMessage: '만료' })),
              value: '3'
            },
            {
              key: '10',
              text: defineMessages(formatMessage({ id: 'AdminLicenseList_14', defaultMessage: '신청취소' })),
              value: '10'
            }
          ];

          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'AdminLicenseList_8', defaultMessage: '상태' }))}
              // filter={
              //   <ReactTableFilterDropdown
              //     listItem={listItem}
              //     filter={searchObj.filterData}
              //     handleChangeFilter={handleChangeFilter}
              //     column={rest.column.id}
              //   />
              // }
            />
          );
        },
        accessor: 'status',
        id: 'status',
        sortable: false,
        resizable: false,
        width: 83,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ value }) => {
          let printValue = defineMessages(formatMessage({ id: 'AdminLicenseList_9', defaultMessage: '미존재' }));
          if (value === 0) {
            printValue = defineMessages(formatMessage({ id: 'AdminLicenseList_10', defaultMessage: '신청' }));
          } else if (value === 1) {
            printValue = defineMessages(formatMessage({ id: 'AdminLicenseList_11', defaultMessage: '사용중' }));
          } else if (value === 2) {
            printValue = defineMessages(formatMessage({ id: 'AdminLicenseList_12', defaultMessage: '사용대기' }));
          } else if (value === 3) {
            printValue = defineMessages(formatMessage({ id: 'AdminLicenseList_13', defaultMessage: '만료' }));
          } else if (value === 10) {
            printValue = defineMessages(formatMessage({ id: 'AdminLicenseList_14', defaultMessage: '신청취소' }));
          } else {
            //
          }
          return printValue;
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminLicenseList_16', defaultMessage: '신청인' }))}
          />
        ),
        accessor: 'orderUserName',
        sortable: true,
        resizable: false,
        minWidth: 110,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center sub-text')
      },
      {
        Header: (
          <ReactTableHeaderText title={defineMessages(formatMessage({ id: 'AdminLog_3', defaultMessage: '이메일' }))} />
        ),
        accessor: 'orderUserEmail',
        sortable: true,
        minWidth: 199,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'sub-text')
      },
      {
        Header: ({ ...rest }) => {
          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'AdminLicenseList_18', defaultMessage: '발급일시' }))}
              filter={
                <ReactTableFilterDatePicker
                  {...rest}
                  filter={searchObj.filterData}
                  onChange={data => {
                    handleChangeDateFilter('IssueEpoch', data);
                  }}
                />
              }
            />
          );
        },
        accessor: 'issueEpoch',
        minWidth: 177,
        sortable: true,
        resizable: false,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center sub-text'),
        Cell: ({ value }) => {
          const dateFormat = localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD';
          return value ? (
            <div>
              <span className={cx('issue-date-normal')}>{moment.unix(value).format(dateFormat + ' HH:mm:ss')}</span>
              <span className={cx('issue-date-fromnow')}>{moment.unix(value).fromNow()}</span>
            </div>
          ) : (
            '-'
          );
        }
      },
      {
        Header: ({ ...rest }) => {
          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'AdminLicenseList_19', defaultMessage: '신청일시' }))}
              filter={
                <ReactTableFilterDatePicker
                  {...rest}
                  filter={searchObj.filterData}
                  onChange={data => {
                    handleChangeDateFilter('RegEpoch', data);
                  }}
                />
              }
            />
          );
        },
        accessor: 'regEpoch',
        minWidth: 177,
        sortable: true,
        resizable: false,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center sub-text'),
        Cell: ({ value }) => {
          const dateFormat = localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD';
          return value ? (
            <div>
              <span className={cx('reg-date-normal')}>{moment.unix(value).format(dateFormat + ' HH:mm:ss')}</span>
              <span className={cx('reg-date-fromnow')}>{moment.unix(value).fromNow()}</span>
            </div>
          ) : (
            '-'
          );
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'AdminLicenseList_20', defaultMessage: '삭제 여부' }))}
          />
        ),
        accessor: 'licenseEnabled',
        id: 'licenseEnabled',
        sortable: true,
        resizable: false,
        width: 110,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ value }) => {
          let printValue = '-';
          if (value === 0) {
            printValue = 'O';
          }
          return printValue;
        }
      }
    ];
    // 구축형일때는 설정 부분을 제거
    commonVar.isSaas === 1 &&
      columns.unshift({
        Header: <ReactTableHeaderText title={<Icon name="setting" />} />,
        resizable: false,
        sortable: false,
        width: 50,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ original }) => {
          return <AdminLicenseInTableMenu isAuth={isAuth} licenseInfo={{ ...original }} />;
        }
      });

    if (fromNowView) {
      for (const key in fromNowView) {
        if (fromNowView.hasOwnProperty(key)) {
          if (fromNowView[key]) {
            fromNowClass.push('from-now-' + key);
          }
        }
      }
    }

    const { TbodyComponent: tbadyWrapper } = ReactTableDefaults;

    return (
      <div className={cx('admin-license-list', 'react-table-area', fromNowClass.join(' '))}>
        <ReactTableSearch
          searchObj={searchObj}
          listData={data}
          //필터 영역
          filters={{
            statusFilter: statusFilter,
            licenseTypeFilter: licenseTypeFilter
          }}
          cancleCheck={cancleCheck}
          filterClose={filterClose}
          executeFilter={executeFilter}
          onFilterCancel={onFilterCancel}
        />
        <div className={cx('react-table')}>
          <ReactTable
            columns={columns}
            data={data}
            sortable={false}
            filterable={false}
            showPagination={false}
            showPageSizeOptions={false}
            defaultSorted={[
              {
                id: 'status',
                desc: true
              }
            ]}
            loadingText={defineMessages(
              formatMessage({ id: 'AdminLicenseList_23', defaultMessage: '데이터 로딩중...' })
            )}
            LoadingComponent={({ ...rest }) => <Loading active={rest.loading} content={rest.loadingText} />}
            FilterComponent={({ ...rest }) => <div />}
            TbodyComponent={({ ...rest }) => (
              <div style={{ ...rest.style }} className={cx('react-table-tbody-wrapper')}>
                <tbadyWrapper {...rest} className={cx('rt-tbody', rest.className ? rest.className : '')} />
              </div>
            )}
            NoDataComponent={({ ...rest }) => (
              <div className={cx('noData-area')}>
                <Image src="/img/table/nodata_icon.png" />
                {defineMessages(formatMessage({ id: 'ExamTemplateList_24', defaultMessage: '데이터가 없습니다.' }))}
              </div>
            )}
            getTheadThProps={(state, rowInfo, column) => {
              const filter = [];
              if (column) {
                // 필터 처리
                if (typeof searchObj.filterData[column.id] !== 'undefined') {
                  filter.push('isFiltered');
                }
                // 정렬 제공 안하는 header
                if (!column.sortable) {
                  filter.push('no-sort');
                }

                return filter.length > 0
                  ? {
                      className: filter.join(' ')
                    }
                  : {};
              }
            }}
            getTrProps={(state, rowInfo, column) => {
              if (rowInfo && rowInfo.original) {
                if (rowInfo.original.licenseEnabled === 0) {
                  return {
                    className: 'delete-item'
                  };
                  // 라이센스 상태(신청중일때)
                } else if (rowInfo.original.approve === 0) {
                  return {
                    className: 'license-applying-item'
                  };
                } else if (rowInfo.original.status === 0) {
                  return {
                    style: {
                      fontWeight: '700',
                      color: '#f2711c'
                    }
                  };
                } else {
                  return {};
                }
              } else {
                return {};
              }
            }}
            {...rest}
          />
        </div>
        <ReactTablePagination
          currentPage={rest.page}
          totalPages={rest.pages ? rest.pages : 0}
          handlePagination={handlePagination}
        />
      </div>
    );
  }
}

AdminLicenseList.propTypes = {
  propFunc: PropTypes.func,
  propNumber: PropTypes.number,
  propString: PropTypes.string,
  propObject: PropTypes.object
};

export default injectIntl(AdminLicenseList);



// WEBPACK FOOTER //
// ./src/script/components/admin/license/AdminLicenseList.js